import styled from 'styled-components'

import type { DefaultTypographyProps } from '../../typography/DefaultTypography'
import type { FontType } from '../../typography/types/FontType'

const StLabel = styled.label<DefaultTypographyProps & { type?: FontType }>`
  ${({ theme, type }) => (type ? theme.Typography[type] : theme.Typography.Label)}

  ${({ color, textAlign, theme }) => {
    return `
      color: ${color ?? 'inherit'};
      textAlign: ${textAlign ?? 'left'};
      margin-bottom: ${theme.UI.SpacingPx.Space2};
    `
  }}

  display: inline-block;

  &[for] {
    cursor: pointer;
  }
`

export { StLabel }
